import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useLoginScreenStyle } from '../hooks/useLoginScreenStyleHook'
import LoginInputField from '../LoginInputField'
import { useTranslation } from 'react-i18next'
import { useLogInMenuHook } from '../hooks/useLogInMenuHook'
import InputErrorPopUp from '../InputErrorPopUp'
import { QRCodeLogin } from '@/clients/streamiq/shared/components/QRCodeLogin'
import ResetPasswordMenu from './ResetPasswordMenu'

const LogInMenu = () => {
    const {
        underLineButtonStyle,
        colorButtonStyle,
        subtitle2Style,
        loginMenuContainer,
        buttonContainerStyles,
        inputContainerStyle,
    } = useLoginScreenStyle()

    const {
        username,
        password,
        inputErrors,
        checkPasswordChange,
        checkUsernameChange,
        logIn,
        isError,
        shouldShowQRLogin,
        showQRCodeHandler,
        isResetPassword,
        setIsResetPassword,
        handleBackToLogin,
    } = useLogInMenuHook()

    const { t: translate } = useTranslation()

    return (
        <Box sx={loginMenuContainer}>
            {shouldShowQRLogin && !isResetPassword && <QRCodeLogin />}

            {!shouldShowQRLogin && !isResetPassword && (
                <>
                    <Typography sx={subtitle2Style}>
                        {translate('existingSubscriberMessage')}
                    </Typography>
                    <>
                        <Box sx={inputContainerStyle}>
                            <LoginInputField
                                placeholder={translate('emailLoginHint')}
                                inputValue={username}
                                setInputValue={checkUsernameChange}
                                defaultValue={'test@merapar.com'}
                                // defaultValue={'codespot15@codespot.io'}
                            />
                            <InputErrorPopUp
                                styles={{
                                    position: 'absolute',
                                    top: '40px',
                                    width: 'max-content',
                                }}
                                errorMessage={translate(
                                    inputErrors.usernameError
                                )}
                            />
                        </Box>

                        <Box sx={inputContainerStyle}>
                            <LoginInputField
                                placeholder={translate('passwordLoginHint')}
                                inputValue={password}
                                defaultValue={'Test1234!'}
                                // defaultValue={'codespotPass'}
                                setInputValue={checkPasswordChange}
                                native={{ type: 'password' }}
                            />
                            <InputErrorPopUp
                                styles={{
                                    position: 'absolute',
                                    top: '50px',
                                    width: 'max-content',
                                }}
                                errorMessage={translate(
                                    inputErrors.passwordError
                                )}
                            />
                        </Box>
                    </>
                    <Box sx={buttonContainerStyles}>
                        <InputErrorPopUp
                            styles={{
                                position: 'absolute',
                                top: '-30px',
                                width: 'max-content',
                            }}
                            errorMessage={translate(
                                inputErrors.dataValidationError
                            )}
                        />

                        <Button
                            sx={colorButtonStyle}
                            onClick={logIn}
                            disabled={isError}>
                            {translate('loginButtonText')}
                        </Button>
                    </Box>

                    {!isResetPassword && (
                        <Button
                            sx={underLineButtonStyle}
                            disableRipple
                            onClick={() => setIsResetPassword(true)}>
                            {translate('forgotPasswordQuestion')}
                        </Button>
                    )}
                </>
            )}

            {!shouldShowQRLogin && isResetPassword && (
                <ResetPasswordMenu handleBackToLogin={handleBackToLogin} />
            )}

            {!isResetPassword && (
                <Box mt="32px">
                    <Button sx={colorButtonStyle} onClick={showQRCodeHandler}>
                        {shouldShowQRLogin
                            ? translate('loginButtonPasswordText')
                            : translate('loginButtonQRText')}
                    </Button>
                </Box>
            )}
        </Box>
    )
}

export default LogInMenu
